import React, { useRef } from "react";
import BusinessTabs from "./BusinessTabs";
import Section from "../../layouts/Section";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FeatureAgentHead from "./FeatureAgentHead";
import Slick from "../Tabs/TabSlickSlide";

const caseList = [
    {
        id: 1,
        CaseimgSrc: "/img/partners/lg_electronic.png"
    },
    {
        id: 2,
        CaseimgSrc: "/img/partners/lg_uplus.png"
    },
    {
        id: 3,
        CaseimgSrc: "/img/partners/hd-infracore.png"
    },
    {
        id: 4,
        CaseimgSrc: "/img/partners/hd-glovis.png"
    },
    {
        id: 5,
        CaseimgSrc: "/img/partners/hl-holdings.png"
    }
];

const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity;
};

export const wrap = (min: number, max: number, v: number) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

const FeatureAgentforce = () => {
    const ref = useRef(null);
    const settings = {
        dots: true,
        autoplay: false,
        Speed: 5000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        arrows: false
    };

    return (
        <>
            <BusinessTabs current="agent" />

            <FeatureAgentHead />
            {/* <div className="container mx-auto max-w-6xl space-y-52 p-6 px-8 py-12 lg:max-w-7xl lg:px-12"></div> */}

            <Section id="1" bg="gray" space="lg">
                <h1 className="mx-auto max-w-6xl text-start text-h1 font-bold tracking-tight text-brand md:text-center">
                    Agentforce란?
                </h1>
                <p className="m-auto mt-4 max-w-6xl text-start text-body font-normal text-black md:text-center">
                    기존의 Salesforce Einstein Copilot을 확장하여 만들어졌으며,
                    Agentforce의 AI 에이전트는 조직 내 다양한 업무를 자율적으로
                    처리합니다.
                    <br className="hidden sm:block" />
                    고객 서비스, 영업, 마케팅 등 다양한 비즈니스 분야에서
                    능동적으로 활동하며 더 나은 고객 경험을 제공하는 자율형
                    에이전트 입니다.
                </p>
                <div className="mx-auto mt-8 max-w-6xl lg:mt-16">
                    <Slick />
                </div>
            </Section>

            <Section bg="white" space="lg">
                <p className="mx-auto mt-4 max-w-6xl text-h3 font-bold text-brand">
                    Enterprise Case
                </p>
                <h1 className="mx-auto mt-4 max-w-6xl text-h1 font-bold tracking-tight text-gray-900">
                    Agentforce를 도입하여 혁신적인 성과를
                    <br className="hidden lg:block" />
                    거두고 있는 기업을 소개합니다.
                </h1>
                <div className="mt-8 flex max-w-6xl flex-col lg:-mx-12 lg:flex xl:m-auto xl:mt-16">
                    <div className="flex-1 lg:mt-0">
                        <div className="grid grid-cols-2 gap-10 md:grid-cols-3 xl:mt-12 xl:gap-16">
                            {caseList.map(list => (
                                <div key={list.id}>
                                    <img
                                        className="m-auto h-[25px] w-[100%] object-contain sm:w-[70%] md:h-[51px]"
                                        src={list.CaseimgSrc}
                                        alt=""
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Section>
        </>
    );
};

export default FeatureAgentforce;
